import { render, staticRenderFns } from "./LmAcceptNotifications.vue?vue&type=template&id=0e19c814"
import script from "./LmAcceptNotifications.vue?vue&type=script&lang=js"
export * from "./LmAcceptNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports